import { defineMessages } from 'react-intl';

export default defineMessages({
    eftPayTitle: {
        id: 'twia.agency.admin.eftpayments.eftPayTitle',
        defaultMessage: 'EFT Payments',
    },
    eftPayMessage: {
        id: 'twia.agency.admin.eftpayments.eftPayMessage',
        defaultMessage: 'EFT Payments must be setup and edited on each Agency/Location separately.',
    },
    enrollmentFailed: {
        id: 'twia.gateway.views.selfservice.eftpayments.enrollmentFailed',
        defaultMessage: 'EFT Enrollment failed for the following reason: {errorMessage}'
    },
    suspendedMessage: { // DE16898
        id: 'twia.agency.admin.eftpayments.suspendedMessage',
        defaultMessage: 'Your EFT Payment Account has been suspended. Please contact TWIA for more information at agentservices@twia.org.',
    },
});
